"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var ng_1 = __importDefault(require("core/services/ng"));
require("core/config");
require("core/main");
require("core/services/storage.js");
require("core/services/notify.js");
require("core/services/api.js");
require("core/services/notification.js");
require("core/services/download.js");
require("core/services/confirmDialog.js");
require("core/services/analytics.js");
require("core/directives");
require("core/filters");
require("core/register");
require("core/password_reset");
/* globals __RINCA_CONFIG__: true */
var appConfig = __RINCA_CONFIG__;
// This module gets overwritten when building for production to create template
// cache. For more information, see the `grunt ngtemplates:core` task.
angular.module('rinca.templates-cache', []);
var core = angular.module('rinca.core', [
    'ngRoute',
    'ngResource',
    'ngSanitize',
    'ui.router',
    'rinca.templates-cache',
    'pathgather.popeye',
    'ui.select',
    '720kb.datepicker',
    'rinca.core.directives',
    'rinca.core.filters',
    'rinca.core.main',
    'rinca.core.storage',
    'rinca.core.notify',
    'rinca.core.api',
    'rinca.notification',
    'rinca.core.download',
    'rinca.core.register',
    'rinca.core.analytics',
    'rinca.core.password_reset',
    'rinca.core.confirmDialog'
]);
core.constant('lodash', lodash_1.default);
// core.config(['$routeProvider', ($routeProvider) => {
//     $routeProvider.when('/', {
//         redirectTo: appConfig.defaultRoute,
//     });
// }]);
// due to angular 1.6
core.config(['$locationProvider', '$urlRouterProvider', function ($locationProvider, $urlRouterProvider) {
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode(false);
        $urlRouterProvider.otherwise('/home');
    }]);
core.config(['$qProvider', function ($qProvider) { return $qProvider.errorOnUnhandledRejections(true); }]);
core.config(['$compileProvider', function ($compileProvider) { return $compileProvider.preAssignBindingsEnabled(true); }]);
core.run(['$injector', ng_1.default.register]);
core.run(['$document', function ($document) {
        if (window.navigator.userAgent.toLowerCase().includes('firefox')) {
            // workaround for firefox drag event not reporting mouse coordinates
            $document.on('dragover', function (event) {
                window.dragPageY = event.pageY;
            });
        }
    }]);
core.config(['uiSelectConfig', function (uiSelectConfig) {
        uiSelectConfig.theme = 'select2';
    }]);
exports.default = core;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/index.ts
// module id = 281
// module chunks = 0